export default __webpack_public_path__ + "657a20455868edf376bc13ecccab851a.png";